import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import api from "../../utills/api";

const SUPERADMIN_TOKEN_KEY = "superadminToken";

const SuperAdminLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("info@yatranest.in");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);
      setError("");

      const response = await api.post(
        "/superadmin/auth/login",
        {
          email,
          password,
        }
      );

      if (!response?.data?.success) {
        throw new Error(
          response?.data?.message ||
            "Superadmin login failed."
        );
      }

      const token =
        response.data?.data?.token;

      if (!token) {
        throw new Error(
          "Superadmin token was not returned."
        );
      }

      localStorage.setItem(
        SUPERADMIN_TOKEN_KEY,
        token
      );

      navigate(
        "/superadmin/dashboard",
        { replace: true }
      );
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Superadmin login failed."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-page-content d-flex align-items-center min-vh-100"
    >
      <Container>
        <Row className="justify-content-center">
          <Col
            xl={5}
            lg={6}
            md={8}
          >
            <Card className="shadow-lg border-0">
              <CardBody className="p-4 p-md-5">
                <div className="text-center mb-4">
                  <h3 className="mb-1">
                    YatraNest Superadmin
                  </h3>
                  <p className="text-muted mb-0">
                    SaaS administration portal
                  </p>
                </div>

                {error && (
                  <Alert
                    color="danger"
                    toggle={() =>
                      setError("")
                    }
                  >
                    {error}
                  </Alert>
                )}

                <Form onSubmit={submit}>
                  <div className="mb-3">
                    <Label>Email</Label>
                    <Input
                      type="email"
                      value={email}
                      onChange={(event) =>
                        setEmail(
                          event.target.value
                        )
                      }
                      required
                      autoComplete="username"
                    />
                  </div>

                  <div className="mb-4">
                    <Label>Password</Label>
                    <Input
                      type="password"
                      value={password}
                      onChange={(event) =>
                        setPassword(
                          event.target.value
                        )
                      }
                      required
                      autoComplete="current-password"
                    />
                  </div>

                  <Button
                    color="primary"
                    className="w-100"
                    type="submit"
                    disabled={loading}
                  >
                    {loading && (
                      <Spinner
                        size="sm"
                        className="me-2"
                      />
                    )}
                    Sign in
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SuperAdminLogin;
